import { render } from "./VXPWhiteCircleLogo.vue?vue&type=template&id=ce98d0ca"
const script = {}

import exportComponent from "/tmp/build_1ea34a31/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__